'use client'

import { useLanguage, useTranslate } from '@repo/shared/hooks'
import {
  SegmentedGroup,
  SegmentedGroupItem,
  Typography,
} from '@repo/ui/components'
import { usePathname } from '@repo/shared/i18n/navigation'

export const SettingsLanguage = () => {
  const { t } = useTranslate()
  const pathname = usePathname()
  const language = useLanguage()

  const handleLanguageChange = (newLocale: string) => {
    // Remove current locale from pathname and add new locale
    const pathWithoutLocale = pathname.replace(`/${language}`, '')
    window.location.href = `/${newLocale}${pathWithoutLocale}`
  }

  return (
    <div className='flex flex-col md:flex-row md:items-center justify-between gap-lg'>
      <Typography size='sm' color='text-neutral-surface-100' weight='bold'>
        {t('profileSettingsPage_language_title')}
      </Typography>

      <SegmentedGroup
        value={language}
        onValueChange={handleLanguageChange}
        color='neutral'
        className='w-full md:w-fit'
      >
        <SegmentedGroupItem value='fa' id='language-persian' className='flex-1'>
          {t('profileSettingsPage_language_persian')}
        </SegmentedGroupItem>

        <SegmentedGroupItem value='en' id='language-english' className='flex-1'>
          {t('profileSettingsPage_language_english')}
        </SegmentedGroupItem>
      </SegmentedGroup>
    </div>
  )
}
